<template>
  <div v-on-clickaway="away">
    <div class="container container--reduced">
      <div class="popup-box__content">
        <div>
          <InPageTitle
            v-if="title"
            :color="'#152d72'"
            class="popup-box__content__title"
          >
            {{ title }}
          </InPageTitle>
          <SubTitle v-if="subTitle" class="popup-box__text">
            {{ subTitle }}
          </SubTitle>
        </div>
        <CrossIcon @crossClicked="closePopup" />
      </div>
      <slot />
    </div>
  </div>
</template>
<script>
import CrossIcon from '@/components/icons/CrossIcon'
import InPageTitle from '@/components/typography/InPageTitle'
import SubTitle from '@/components/typography/SubTitle'
import { mixin as clickaway } from 'vue-clickaway'

export default {
  name: 'PopupBox',
  components: {
    CrossIcon,
    InPageTitle,
    SubTitle
  },
  mixins: [clickaway],
  props: {
    title: {
      type: String,
      default: null
    },
    subTitle: {
      type: String,
      default: null
    }
  },
  beforeDestroy () {
    this.removePopupOpenClass()
  },
  methods: {
    removeModalDiv () {
      const elem = document.querySelector('.modal-bg')
      if (elem) {
        elem.remove()
      }
    },
    removePopupOpenClass () {
      this.removeModalDiv()
      document.body.classList.remove('popup-open')
    },
    closePopup () {
      this.removePopupOpenClass()
      this.$emit('closePopup')
      this.removeModalDiv()
    },
    away () {
      this.closePopup()
    }
  }
}
</script>
<style lang="scss">
.popup-open {
  .page {
    margin-top: 0;
    height: 0 !important;
  }

  .nav-bar {
    z-index: 1 !important;
  }
}
</style>

<style lang="scss" scoped>
.popup-box {
  background-color: #f7f8f9;
  position: fixed;
  top: 19px;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 1;
  border-radius: 13px;
  overflow: scroll;

  @media (min-width: $screen-md) {
    top: 75px;
  }

  &__content {
    position: sticky;
    top: 0px;
    z-index: 55555;
    background-color: #f7f8f9;
    padding-top: 20px;
    padding-bottom: 20px;

    @media (min-width: $screen-md) {
      padding-top: 25px;
      padding-bottom: 25px;
    }

    &__title {
      @media (min-width: $screen-md) {
        margin-bottom: 15px;
      }
    }
  }

  &__text {
    margin-bottom: 0;

    @media (max-width: $screen-md) {
      font-size: 10px;
    }
  }

  &__title,
  &__text {
    text-align: left;
  }

  .container--reduced {
    padding-left: 10px;
    padding-right: 10px;

    @media (min-width: 1200px) {
      padding-left: 15px;
      padding-right: 15px;
      max-width: 995px;
    }
  }
}
</style>
